var model = {
  defaultTitle: 'Emploisdutemps.fr',
  appBarTitle: 'Emploisdutemps.fr',
  oldAppBarTitle: '',
  oldDocumentTitle: '',
  isLoading: false,
  edt: null,
}

const setTitle = (title, keepEdt = false) => {
  document.getElementsByTagName('title')[0].textContent = (title + ' | ' + model.defaultTitle);
  model.appBarTitle = title;
  if(!keepEdt) {
    model.edt = null;
  }
  model.isLoading = false;
  sendEvent('appViewModelChanged');
}

const setIsLoading = (isLoading = false) => {
  let titleElt = document.getElementsByTagName('title')[0];
  model.isLoading = isLoading;
  if(isLoading) {
    model.oldDocumentTitle = titleElt.textContent;
    model.oldAppBarTitle = model.appBarTitle;
    titleElt.textContent = model.defaultTitle;
  }
  sendEvent('appViewModelChanged');
}

const resetAppBarTitle = () => {
  let titleElt = document.getElementsByTagName('title')[0];
  if(titleElt.textContent === model.defaultTitle) {
    model.isLoading = false;
    titleElt.textContent = model.oldDocumentTitle;
    model.appBarTitle = model.oldAppBarTitle;
    sendEvent('appViewModelChanged');
  }
}

const setEdt = (edt) => {
  model.edt = edt;
  sendEvent('appViewModelChanged');
}

const sendEvent = (eventType, details) => {
  if(CustomEvent.prototype.initCustomEvent) {
    let event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventType, true, true, details);

    document.body.dispatchEvent(event);
  } else {
    document.body.dispatchEvent(new CustomEvent(eventType, {
      detail: details
    }));
  }
} 

export default {
  model,
  setTitle,
  setIsLoading,
  resetAppBarTitle,
  setEdt,
  sendEvent,
};


// WEBPACK FOOTER //
// ./src/ViewModel.js